import { useEffect, useState, type Ref } from "react";
import { useWatch, type Control } from "react-hook-form";
import { FormControl, FormLabel } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { FormInput } from "@/components/ui/forms/formInputComponent/formInput.component";
import { LOGIN_FIELD_LABEL_CLASSNAME, LOGIN_TEXT_FIELD_CLASSNAME } from "../../loginForm.constants";
import type { FormularioLoginUnificado } from "../loginUnificado.schema";
import type { FormularioEntrarJwtProps } from "../../FormularioEntrarJwt";

// --------------------------------- TYPES ---------------------------------
type CampoSenhaLoginUnificadoProps = FormularioEntrarJwtProps & {
	readonly control: Control<FormularioLoginUnificado>;
	readonly inputRef: Ref<HTMLInputElement>;
	readonly carregando: boolean;
};

// ------------------------------- COMPONENT -------------------------------
export default function CampoSenhaLoginUnificado({
	control,
	inputRef,
	carregando,
	densidade,
}: Readonly<CampoSenhaLoginUnificadoProps>) {
	// -------------------------------- STATES --------------------------------
	const [exibirSenha, setExibirSenha] = useState(false);
	const senha = useWatch({ control, name: "password" });

	// -------------------------------- EFFECTS -------------------------------
	useEffect(() => {
		if (!senha) setExibirSenha(false);
	}, [senha]);

	// -------------------------------- RETURN --------------------------------
	return (
		<FormControl fullWidth>
			<FormLabel htmlFor="password" className={LOGIN_FIELD_LABEL_CLASSNAME}>
				Senha
			</FormLabel>
			<FormInput<FormularioLoginUnificado>
				control={control}
				name="password"
				parse={(valor) => valor}
				id="password"
				placeholder="Digite sua senha"
				autoComplete="current-password"
				type={exibirSenha ? "text" : "password"}
				className={LOGIN_TEXT_FIELD_CLASSNAME}
				inputRef={inputRef}
				disabled={carregando}
				upperCaseValue={false}
				highlightActiveSelection={false}
				size="small"
				reserveHelperText={densidade !== "compacta"}
				leftIcon={
					<FuseSvgIcon size={14} className="text-[#99aabb]">
						lucide:lock
					</FuseSvgIcon>
				}
				rightIcon={
					<FuseSvgIcon size={16} className="text-[#99aabb]">
						{exibirSenha ? "lucide:eye-off" : "lucide:eye"}
					</FuseSvgIcon>
				}
				rightIconAriaLabel={exibirSenha ? "Ocultar senha" : "Mostrar senha"}
				onRightIconClick={() => setExibirSenha((atual) => !atual)}
			/>
		</FormControl>
	);
}
